const ARCHIVE_LOADING = "ARCHIVE_LOADING";
const ARCHIVE_ERROR = "ARCHIVE_ERROR";
const ARCHIVE_SUCCESS = "ARCHIVE_SUCCESS";

export { ARCHIVE_LOADING, ARCHIVE_ERROR, ARCHIVE_SUCCESS };